import Modal from 'components/UpdateMemberDetailModal'
import ProfileUpdate from 'views/MemberProfile/Profile/UpdateDetails'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalPurchase = ({ title, open, onClose }: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <ProfileUpdate onClose={onClose} />
    </Modal>
  )
}

export default ModalPurchase
